<template>
    <div>
        <div v-for="(item, i) in state" :key="i" class="mb-2">
            <input
                type="text"
                v-model="state[i].school_key"
                :name="`skola[${i}][school_key]`"
            >
        </div>
        <button class="btn btn-outline-primary" @click.prevent="addSchool()">Přidat</button>
    </div>
</template>

<script>
    export default {
        props: [
            'old'
        ],

        data: () => ({
            state: []
        }),

        methods: {
            addSchool() {
                this.state.push({
                    school_key: null
                });
            }
        },

        mounted() {
            let that = this;

            if (this.old === null) {
                this.addSchool();
                return;
            }

            this.old.forEach((item) => {
                that.state.push({
                    school_key: item.school_key
                })
            });
        }
    }
</script>
